import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import FlowTables from "./FlowTables";
import btnDownloadIcon from "./../../Assests/download.svg";
import {
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
} from "../../Redux/Actions/InputData";
import {
  API_BASE_URL,
  DISPLAY_LANDED_COST_API,
  DOWNLOAD_LANDED_COST_TABLE_API,
  VIEW_LANDED_COST_TABLE_API,
  HOME_FLOW_DROPDOWN_FILTER_API,
  HOMECARE_GET_TABLE_API,
  NUTRITION_GET_TABLE_API,
  MEDIUM_HOMECARE_GET_TABLE_API,
  MEDIUM_NUTRITION_GET_TABLE_API,
} from "../../Utils/Config";
import { getRequest, postRequest } from "../../Services/AxiosConfiguration";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import * as actions from "../../Redux/Actions/index";

function LandedCost(props: any) {
  const dispatch: any = useDispatch();
  const [selectFactory, setSelectFactory] = useState<any>("");
  const [selectBasepack, setSelectBasepack] = useState<any>("");
  const [selectLine, setSelectLine] = useState<any>("");
  const [selectTimePeriod, setSelectTimePeriod] = useState<any>("");
  const [rowsData, setRows] = React.useState([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [factoryOptions, setFactoryOptions] = React.useState([]);
  const [basepackOptions, setBasepackOptions] = useState<any>([]);
  const [lineOptions, setLineOptions] = useState<any>([]);
  const [timePeriodOptions, setTimePeriodOptions] = useState<any>([]);
  const [pageIsLoaded, setPageIsLoaded] = useState<any>(false);
  const [tableColumnsDef, setTableColumnsDef] = useState<any>([]);
  // const [filterRequest, setFilterRequest] = React.useState([{"key":"factory","value":""},{"key":"line","value":""},{"key":"basepack","value":""},{"key":"time_period","value":""}]);
  const [filterRequest, setFilterRequest] = React.useState([
    { key: "factory", value: "" },
    { key: "basepack", value: "" },
    { key: "time_period", value: "" },
  ]);

  const sortedFactoryNames = factoryOptions.sort((a: any, b: any) =>
    a?.factory_Name.localeCompare(b?.factory_Name),
  );

  //flow dropdown filter options
  const [filterDropdownOptions, setFilterDropdownOptions] = useState<any>([]);

  const [selectFlowFilterOption, setSelectFlowFilterOption] = useState<any>({
    displayName: "Pri_Transportation_Data",
    flowTableName: "flow_Depo_HCMT",
  });
  const [pritransportationalco2Data, setPritransportationalco2Data] =
    useState<any>([]);

  var base = 0;
  var time = 0;

  /**Redux state */
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId,
  );

  if (selectedFolderId) {
    console.log("InputData Modal selectedFolderId: ", selectedFolderId);
  }

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );

  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );
  const selectedTimePeriodData = useSelector(
    (state: any) => state.InputDataReducers.selectedTimePeriodData,
  );

  if (selectedUsecaseId) {
    console.log("InputData Modal selectedUsecaseId: ", selectedUsecaseId);
  }
  useEffect(() => {
    if (
      selectedUsecaseId === undefined ||
      selectedCategoryId === undefined ||
      selectedFolderId === undefined ||
      selectedScenarioId === undefined
    ) {
      setPageIsLoaded(true);
    } else {
      setPageIsLoaded(false);
    }

    if (selectedCategoryId === 2) {
      handleaddInitialValue2();
    } else {
      handleaddInitialValue1();
    }
  }, []);

  useEffect(() => {
    callTableGridApi(selectFlowFilterOption, "dropdown");
  }, [selectedTimePeriodData]);

  const handleChangeSelectFlowFilter = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectFlowFilterOption(value);
    callTableGridApi(value, "dropdown");
  };

  const handleaddInitialValue1 = () => {
    setSelectFlowFilterOption({
      displayName: "Pri_Transportation_Data",
      flowTableName: "flow_Depo_HCMT",
    });
    callTableGridApi(
      {
        displayName: "Pri_Transportation_Data",
        flowTableName: "flow_Depo_HCMT",
      },
      "dropdown",
    );
  };

  const handleaddInitialValue2 = () => {
    setSelectFlowFilterOption({
      displayName: "Pri_Transportation_Data",
      flowTableName: "flow_vol_depo_Nut_MT",
    });
    callTableGridApi(
      {
        displayName: "Pri_Transportation_Data",
        flowTableName: "flow_vol_depo_Nut_MT",
      },
      "dropdown",
    );
  };

  function toCamelCase(inputString: string) {
    return inputString.replace(/\w\S*/g, function (txt) {
      return (
        txt.charAt(0).toUpperCase() +
        txt.substr(1).toLowerCase().replaceAll("_", " ")
      );
    });
  }
  const callTableGridApi = (value?: any, type?: string) => {
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_Id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: value?.flowTableName,
      // table: selectedCategoryId === 2 ? "flow_vol_depo_Nut_MT" : "flow_Depo_HCMT",
      filter: [],
    };
    let url =
      type === "dropdown"
        ? "getpritransportationdataall"
        : "getpritransportationdatadownload";
    dispatch(ViewProductTableStart());
    if (selectedCategoryId === 1) {
      switch (value?.flowTableName) {
        case "flow_Depo_HCMT":
          url =
            type === "dropdown"
              ? "getpritransportationdataall"
              : "getpritransportationdatadownload";
          break;
        case "flow_Landed_Cost_HCMT":
          url =
            type === "dropdown" ? "getlandeddataall" : "getlandeddatadownload";
          break;
        case "flow_Volume_prod_HCMT":
          url =
            type === "dropdown"
              ? "getproductiondataall"
              : "getproductiondatadownload";
          break;
        case "flow_no_of_shifts_HCMT":
          url =
            type === "dropdown"
              ? "getshiftallocationdataall"
              : "getshiftallocationdatadownload";
          break;
        case "flow_Distance_HCMT":
          url =
            type === "dropdown"
              ? "getdistancedataall"
              : "getdistancedatadownload";
          break;
        case "flow_CO2_Manufacturing_HCMT":
          url =
            type === "dropdown"
              ? "getproductioncodataall"
              : "getproductioncodatadownload";
          break;
        case "flow_CO2_Pri_Transport_HCMT":
          url =
            type === "dropdown"
              ? "getpritransportationcodataall"
              : "getpritransportationcodatadownload";
          break;
      }
    } else {
      switch (value?.flowTableName) {
        case "flow_no_of_shifts_Nut_MT":
          url =
            type === "dropdown"
              ? "getshiftallocationdataall"
              : "getshiftallocationdatadownload";
          break;
        case "flow_vol_depo_Nut_MT":
          url =
            type === "dropdown"
              ? "getpritransportationdataall"
              : "getpritransportationdatadownload";
          break;
        case "flow_vol_MinorIngr_LandedCost_Nut_MT":
          url =
            type === "dropdown"
              ? "getmilandeddataall"
              : "getmilandeddatadownload";
          break;
        case "flow_vol_packaging_Nut_MT":
          url =
            type === "dropdown"
              ? "getpackagingdataall"
              : "getpackagingdatadownload";
          break;
        case "flow_vol_PrimaryTransportation_Nut_MT":
          url =
            type === "dropdown"
              ? "getpritransLeadtimeandco2dataall"
              : "getpritransLeadtimeandco2datadownload";
          break;
        case "flow_vol_processing_Nut_MT":
          url =
            type === "dropdown"
              ? "getmanufacturingdataall"
              : "getmanufacturingdatadownload";
          break;
        case "flow_vol_SFGLandedCost_Nut_MT":
          url =
            type === "dropdown"
              ? "getrmlandeddataall"
              : "getrmlandeddatadownload";
          break;
        case "flow_vol_SFGtransportation_Nut_MT":
          url =
            type === "dropdown"
              ? "getsfgtransportationco2dataall"
              : "getsfgtransportationco2datadownload";
          break;
        case "flow_vol_transportation_sfg_Nut_MT":
          url =
            type === "dropdown"
              ? "getsfgtransportationdataall"
              : "getsfgtransportationdatadownload";
          break;
      }
    }
    const urls = API_BASE_URL + MEDIUM_HOMECARE_GET_TABLE_API + url;
    const Nurls = API_BASE_URL + MEDIUM_NUTRITION_GET_TABLE_API + url;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(
      selectedCategoryId === 1 ? urls : Nurls,
      requestParam,
      header,
      {},
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          if (type === "dropdown") {
            setIsProcessed(true);
            const columns: any = [];
            if (response.data.length > 0 && response.data) {
              const filteredData =
                Array.isArray(selectedTimePeriodData) &&
                selectedTimePeriodData.length > 0
                  ? response.data.filter((row: any) =>
                      selectedTimePeriodData.includes(row.time_Period),
                    )
                  : response.data;
              setRows(filteredData);
              Object.keys(
                filteredData?.length > 0 ? filteredData[0] : response.data[0],
              ).map((col) => {
                columns.push({
                  id: col,
                  label: toCamelCase(col),
                  minWidth: 100,
                  fontWeight: 600,
                });
              });
            }
            if (columns.length > 0) {
              setTableColumnsDef(columns);
            }
          } else {
            // let blob = new Blob([response.data], {
            //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            // });
            // //FileSaver(blob, Date.now() + '.xlsx');
            // FileSaver(blob, "Optimized Output.xlsx");

            axios({
              url: selectedCategoryId === 1 ? urls : Nurls,
              method: "post",
              responseType: "arraybuffer",
              headers: { "Content-Type": "application/json;" },
              data: requestParam,
            }).then((response) => {
              let blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              FileSaver(blob, "Optimized Output" + ".xlsx");
            });
          }
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  useEffect(() => {
    const requestParam = {
      usecase_id: selectedUsecaseId,
      category_id: selectedCategoryId,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + HOME_FLOW_DROPDOWN_FILTER_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(urls, requestParam, header)
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log("responsedata", response.data);
          setFilterDropdownOptions(response.data);
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  }, [selectedUsecaseId, selectedCategoryId]);

  const loadTimePeriodOptions = (data: any) => {
    console.log(data, "dateeeeeeeee");
    const timePeriodPackOptions: any = [];
    data.map((item: any) => {
      const filteredItem = timePeriodPackOptions.find((obj: any) => {
        return obj.time_Period === item.time_period;
      });
      if (filteredItem === undefined || filteredItem == null) {
        timePeriodPackOptions.push({
          id: item.id,
          time_Period: item.time_period,
        });
      }
    });
    return timePeriodPackOptions;
    //setTimePeriodOptions(timePeriodPackOptions);
  };

  const loadBasePackOptions = (data: any) => {
    const basePackOptions: any = [];
    data.map((item: any) => {
      const filteredItem = basePackOptions.find((obj: any) => {
        return obj.basepack === item.basepack;
      });
      if (filteredItem === undefined || filteredItem == null) {
        basePackOptions.push({ id: item.id, basepack: item.basepack });
      }
    });
    //setBasepackOptions(basePackOptions);
    return basePackOptions;
  };

  const getfiltersApi = () => {
    //let timePeriodValues = selectedTimePeriodData.join(',');
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    // console.log("Time Period Join_______________________________________", timePeriodValues)
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblLandedCost", "ispagination": 1, "page": 1, "pagesize": 100, "filter": filterList };
    //const requestParam = { "usecaseId": selectedUsecaseId, "category_id": selectedCategoryId,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": selectedScenarioId === 0 ?"tblLandedCost" : "tblScenario_LandedCost", "time_period": "string","ispagination": 1, "page": 1, "pagesize": 100, "filter":  filterList };
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: scenarioId === 0 ? "tblLandedCost" : "tblScenario_LandedCost",
      time_period: "string",
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + DISPLAY_LANDED_COST_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setFactoryOptions(response.data.factoryFilter);
          setBasepackOptions(response.data.basepackFilter);
          setLineOptions(response.data.lineFilter);
          setTimePeriodOptions(response.data.time_periodFilter);
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const handleRestoreClicked = (e: any) => {
    setSelectFactory("");
    setSelectBasepack("");
    setSelectTimePeriod("");
    setSelectLine("");
    setFilterRequest([
      { key: "factory", value: "" },
      { key: "basepack", value: "" },
      { key: "time_period", value: "" },
    ]);
    filterRequest[0].value = "";
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
  };

  const handleDownload = (e: any) => {
    callTableGridApi(selectFlowFilterOption, "download");
  };

  const downloadXLSFile = async () => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    // console.log("Time Period Join_______________________________________", timePeriodValues)
    const filterList = filterRequest.filter((elem: any) => elem.value != "");

    //const requestParam = { "usecaseId": selectedUsecaseId, "category_id": selectedCategoryId,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": selectedScenarioId === 0 ?"tblLandedCost" : "tblScenario_LandedCost", "time_period": "", "filter": filterList };
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: scenarioId === 0 ? "tblLandedCost" : "tblScenario_LandedCost",
      time_period: "",
      filter: filterList,
    };
    const urls = API_BASE_URL + DOWNLOAD_LANDED_COST_TABLE_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  return (
    <>
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>Flows</h3>
          </div>
          <div className="filters">
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
                titleAccess="Reset"
              />
            </span>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Select Flow</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectFlowFilterOption}
                  placeholder="Select Flows"
                  onChange={handleChangeSelectFlowFilter}
                  renderValue={(selectFlowFilterOption: any) =>
                    selectFlowFilterOption?.displayName
                  }
                  className="select-short-term"
                >
                  {filterDropdownOptions.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d}>
                        {d.displayName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth>
                <div className="content-download-btn" onClick={handleDownload}>
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <FlowTables
          isProcessed={isProcessed}
          rowsData={rowsData}
          columns={tableColumnsDef}
        />
      </div>
    </>
  );
}

export default LandedCost;
